export const junctionlist = [
  {
    id: "node13",
    x: 838.5,
    y: 456.5,
    tx: 843,
    ty: 479.65,
    content: `Pharmacy/Shop`
  },
  {
    id: "node12",
    x: 838.5,
    y: 354.5,
    tx: 842.93,
    ty: 377.65,
    content: `Private Facility`
  },
  {
    id: "node11",
    x: 838.5,
    y: 253.5,
    tx: 852.99,
    ty: 276.65,
    content: `NGO Facility`
  },
  {
    id: "node10",
    x: 838.5,
    y: 150.5,
    tx: 845.57,
    ty: 173.65,
    content: `Public Facility`
  },
  {
    id: "node9",
    x: 496.5,
    y: 406.5,
    tx: 508.96,
    ty: 423.62,
    content: `Wholesaler/<tspan x="2.74" y="12.07">Distributer</tspan>`
  },
  {
    id: "node8",
    x: 496.5,
    y: 303.5,
    tx: 520.9,
    ty: 326.65,
    content: `NGO/SMO`
  },
  {
    id: "node7",
    x: 496.5,
    y: 202.5,
    tx: 509.85,
    ty: 225.65,
    content: `Government`
  },
  {
    id: "node6",
    x: 268.5,
    y: 405.5,
    tx: 273.35,
    ty: 422.62,
    content: `Manufacturer/<tspan x="9.68" y="12.07">Wholesaler</tspan>`
  },
  {
    id: "node5",
    x: 268.5,
    y: 303.5,
    tx: 285.36,
    ty: 326.65,
    content: `Donor/NGO`
  },
  {
    id: "node4",
    x: 268.5,
    y: 202.5,
    tx: 291.31,
    ty: 219.62,
    content: `Domestic<tspan x="-9.47" y="12.07">Government</tspan>`
  },
  {
    id: "node3",
    x: 2.5,
    y: 405.5,
    tx: 7.35,
    ty: 422.62,
    content: `Manufacturer/<tspan x="9.68" y="12.07">Wholesaler</tspan>`
  },
  {
    id: "node2",
    x: 2.5,
    y: 303.5,
    tx: 19.36,
    ty: 326.65,
    content: `Donor/NGO`
  },
  {
    id: "node1",
    x: 2.5,
    y: 201.5,
    tx: 25.31,
    ty: 218.62,
    content: `Domestic<tspan x="-9.47" y="12.07">Government</tspan>`
  }
];
